export interface TeachersPageUrlState {
  search: string;
  location: string | null;
  /** 1-based page number for the URL; omitted from query when 1. */
  page: number;
}

export const EMPTY_TEACHERS_PAGE_URL_STATE: TeachersPageUrlState = {
  search: "",
  location: null,
  page: 1,
};

export const TEACHERS_PAGE_SIZE = 10;

function parsePage(value: string | null): number {
  if (value == null || value.trim() === "") return 1;
  const parsed = Number.parseInt(value, 10);
  return Number.isFinite(parsed) && parsed >= 1 ? parsed : 1;
}

function parseOptionalString(value: string | null): string | null {
  const trimmed = value?.trim() ?? "";
  return trimmed ? trimmed : null;
}

export function teachersPageUrlStateEqual(
  a: TeachersPageUrlState,
  b: TeachersPageUrlState,
): boolean {
  return (
    a.search === b.search &&
    a.location === b.location &&
    a.page === b.page
  );
}

export function parseTeachersPageParamsFromSearchParams(
  searchParams: URLSearchParams,
): TeachersPageUrlState {
  return {
    search: searchParams.get("q")?.trim() ?? "",
    location: parseOptionalString(searchParams.get("location")),
    page: parsePage(searchParams.get("page")),
  };
}

export function buildTeachersPageQuery(state: TeachersPageUrlState): string {
  const params = new URLSearchParams();

  if (state.search.trim()) {
    params.set("q", state.search.trim());
  }
  if (state.location) {
    params.set("location", state.location);
  }
  if (state.page > 1) {
    params.set("page", String(state.page));
  }

  const query = params.toString();
  return query ? `?${query}` : "";
}

export function teachersPageParamsMatchSearchParams(
  state: TeachersPageUrlState,
  searchParams: URLSearchParams,
): boolean {
  return teachersPageUrlStateEqual(
    state,
    parseTeachersPageParamsFromSearchParams(searchParams),
  );
}
